export default {
    BASE_URL_PREFIX: 'http://newsdata.peopletech.cn/appapi'
};



// WEBPACK FOOTER //
// ./src/config/prod.js